"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bottomQrcodeGetApi = bottomQrcodeGetApi;
exports.bottomQrcodeSaveApi = bottomQrcodeSaveApi;
exports.pcBaseConfigEditApi = pcBaseConfigEditApi;
exports.pcBaseConfigGetApi = pcBaseConfigGetApi;
exports.pcBottomAuthorizGetApi = pcBottomAuthorizGetApi;
exports.pcBottomAuthorizeSaveApi = pcBottomAuthorizeSaveApi;
exports.pcFriendlyLinkGetApi = pcFriendlyLinkGetApi;
exports.pcFriendlyLinkSaveApi = pcFriendlyLinkSaveApi;
exports.pcHomeAdvertisementEditApi = pcHomeAdvertisementEditApi;
exports.pcHomeAdvertisementGetApi = pcHomeAdvertisementGetApi;
exports.pcHomeBannerGetApi = pcHomeBannerGetApi;
exports.pcHomeBannerSaveApi = pcHomeBannerSaveApi;
exports.pcHomeNavigationGetApi = pcHomeNavigationGetApi;
exports.pcHomeNavigationSaveApi = pcHomeNavigationSaveApi;
exports.pcPhilosophyGetApi = pcPhilosophyGetApi;
exports.pcPhilosophySaveApi = pcPhilosophySaveApi;
exports.pcRecommendedAddApi = pcRecommendedAddApi;
exports.pcRecommendedDeleteApi = pcRecommendedDeleteApi;
exports.pcRecommendedEditApi = pcRecommendedEditApi;
exports.pcRecommendedListApi = pcRecommendedListApi;
exports.pcRecommendedSwitchApi = pcRecommendedSwitchApi;
exports.shoppingQuickEntryGetApi = shoppingQuickEntryGetApi;
exports.shoppingQuickEntrySaveApi = shoppingQuickEntrySaveApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 添加PC商城首页推荐板块
 */
function pcRecommendedAddApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/recommended/add",
    method: 'post',
    data: data
  });
}

/**
 * 编辑PC商城首页推荐板块
 */
function pcRecommendedEditApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/recommended/edit",
    method: 'post',
    data: data
  });
}

/**
 * 编辑PC商城首页推荐板块
 */
function pcRecommendedListApi() {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/get/recommended/list",
    method: 'get'
  });
}

/**
 * PC商城首页推荐板块开关
 */
function pcRecommendedSwitchApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/recommended/switch/".concat(id),
    method: 'post'
  });
}

/**
 * 删除PC商城首页推荐板块
 */
function pcRecommendedDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/recommended/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 保存PC商城首页banner
 */
function pcHomeBannerSaveApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/home/banner/save",
    method: 'post',
    data: data
  });
}

/**
 * 获取PC商城首页banner
 */
function pcHomeBannerGetApi() {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/home/banner/get",
    method: 'get'
  });
}

/**
 * 获取PC商城经营理念配置
 */
function pcPhilosophyGetApi() {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/philosophy/get",
    method: 'get'
  });
}

/**
 * 保存PC商城经营理念配置
 */
function pcPhilosophySaveApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/philosophy/save",
    method: 'post',
    data: data
  });
}

/**
 * 保存PC商城底部授权配置
 */
function pcBottomAuthorizeSaveApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/bottom/authorize/save",
    method: 'post',
    data: data
  });
}

/**
 * 获取PC商城底部授权配置
 */
function pcBottomAuthorizGetApi() {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/bottom/authorize/get",
    method: 'get'
  });
}

/**
 * 获取PC商城基础配置
 */
function pcBaseConfigGetApi() {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/base/config/get",
    method: 'get'
  });
}

/**
 * 编辑PC商城基础配置
 */
function pcBaseConfigEditApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/base/config/edit",
    method: 'post',
    data: data
  });
}

/**
 * 保存PC商城友情链接配置
 */
function pcFriendlyLinkSaveApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/friendly/link/save",
    method: 'post',
    data: data
  });
}

/**
 * 获取PC商城友情链接配置
 */
function pcFriendlyLinkGetApi() {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/friendly/link/get",
    method: 'get'
  });
}

/**
 * 保存PC商城友情链接配置
 */
function bottomQrcodeSaveApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/bottom/qrcode/save",
    method: 'post',
    data: data
  });
}

/**
 * 获取PC商城友情链接配置
 */
function bottomQrcodeGetApi() {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/bottom/qrcode/get",
    method: 'get'
  });
}

/**
 * 保存PC商城快捷入口配置
 */
function shoppingQuickEntrySaveApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/quick/entry/save",
    method: 'post',
    data: data
  });
}

/**
 * 获取PC商城快捷入口配置
 */
function shoppingQuickEntryGetApi() {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/quick/entry/get",
    method: 'get'
  });
}

/**
 * 编辑PC商城首页广告
 */
function pcHomeAdvertisementEditApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/home/advertisement/edit",
    method: 'post',
    data: data
  });
}

/**
 * 获取PC商城首页广告
 */
function pcHomeAdvertisementGetApi() {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/home/advertisement/get",
    method: 'get'
  });
}

/**
 * 保存PC商城首页导航配置
 */
function pcHomeNavigationSaveApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/home/navigation/save",
    method: 'post',
    data: data
  });
}

/**
 * 获取PC商城首页导航配置
 */
function pcHomeNavigationGetApi() {
  return (0, _request.default)({
    url: "/admin/platform/pc/shopping/home/navigation/get",
    method: 'get'
  });
}